import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem('isLoggedIn') === 'true'
  );

  const [country, setCountry] = useState(
    localStorage.getItem('country') || ''
  );

  const [userType, setUserType] = useState(
    localStorage.getItem('userType') || ''
  );

  const [token, setToken] = useState(
    localStorage.getItem('token') || ''
  );

  // ✅ Check on every reload if current time passed midnight
  useEffect(() => {
    const logoutAt = localStorage.getItem("logoutAt");

    if (logoutAt) {
      const now = Date.now();

      if (now >= parseInt(logoutAt, 10)) {
        // ⏰ It's already past midnight — logout immediately
        localStorage.clear();
        setIsLoggedIn(false);
        console.log("⏰ Auto logged out because it’s past midnight");
        window.location.href = "/"; // Redirect to login
      } else {
        // ⏰ Schedule remaining time until midnight
        const timeLeft = parseInt(logoutAt, 10) - now;

        const timer = setTimeout(() => {
          localStorage.clear();
          setIsLoggedIn(false);
          alert("Your session expired at midnight. Please login again.");
          window.location.href = "/";
        }, timeLeft);

        return () => clearTimeout(timer);
      }
    }
  }, []);


  const handleSetIsLoggedIn = (status) => {
    setIsLoggedIn(status);
    localStorage.setItem('isLoggedIn', status);
  };

  const handleSetCountry = (country) => {
    setCountry(country);
    localStorage.setItem('country', country);
  };

  const handleSetUserType = (userType) => {
    setUserType(userType);
    localStorage.setItem('userType', userType);
  };

  const handleSetToken = (newToken) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn: handleSetIsLoggedIn,
        country,
        setCountry: handleSetCountry,
        userType,
        setUserType: handleSetUserType,
        token,
        setToken: handleSetToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
